import React from 'react';

export default function DupicateIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-dupicate"><rect width="14" height="14" x="3" y="3" className="secondary" rx="2"/><rect width="14" height="14" x="7" y="7" className="primary" rx="2"/></svg>
    </Tag>
  )
};
